
import { UniversalService } from '@commoncore/services/universal.service';
import { ENV_CONSTANTS } from '@env-properties/environment';
import { GlobalClassInstance } from '../constants/GlobalClass';
declare var require: any;

export class JustifiedView {
  public fluidDimensions:any;

  constructor(public universalService:UniversalService) { }


  generateJustifiedView(files,parentId,targetRowHeightTolerance){
    this.universalService.currentFiles  = files;
    var containerWidth;
    var targetRowHeight;
    for(var i=0;i<files.length;i++){ //files.length
      for(var j=0;j<files[i]["objects"].length;j++){ //first objects month.length
        if (!files[i]["objects"][j].width || files[i]["objects"][j].width == "100%") {
          files[i]["objects"][j].width = 800;
          files[i]["objects"][j].recalculation = true;
        }
        if (!files[i]["objects"][j].height || files[i]["objects"][j].height == "100%") {
          files[i]["objects"][j].height = 800;
          files[i]["objects"][j].recalculation = true;
        }

        var orientation = null;
        var rawFile = Object.assign({}, files[i]["objects"][j]);

        if (!files[i]["objects"][j]["inverted"] && files[i]["objects"][j].isOrientationHandle == undefined && rawFile.orientation != undefined && (rawFile.orientation.indexOf("90") != -1 || rawFile.orientation.indexOf("270") != -1)) {
          files[i]["objects"][j].width = rawFile.height;
          files[i]["objects"][j].height = rawFile.width;
          files[i]["objects"][j].isOrientationHandle = true;
          files[i]["objects"][j]["inverted"] = true;
        }
      }
    }

      if (window.innerWidth > 768) {
        containerWidth = jQuery(parentId).width() || 1250;
        targetRowHeight = 200;
      } else {
        containerWidth = jQuery(parentId).width() || window.innerWidth;
        targetRowHeight = 120;
      }
    
      
      for(var i=0;i<files.length;i++){
        this.fluidDimensions = require('justified-layout')(files[i]["objects"], {
          targetRowHeight: targetRowHeight,
          containerWidth: containerWidth,
          targetRowHeightTolerance: targetRowHeightTolerance,
          boxSpacing: {
            horizontal: 10,
            vertical: 30
          }
        });


          for(var j=0;j<files[i]["objects"].length;j++){
            files[i]["objects"][j]["thumbnailWidth"] = undefined;
            files[i]["objects"][j]["thumbnailHeight"] = undefined;
            files[i]["objects"][j]["thumbnailLeft"] = undefined;
            files[i]["objects"][j]["thumbnailTop"] = undefined;
            files[i]["objects"][j]["thumbnailWidth"] = Math.round(this.fluidDimensions.boxes[j]['width'])
            files[i]["objects"][j]["thumbnailHeight"] = Math.round(this.fluidDimensions.boxes[j]['height']);
            files[i]["objects"][j]["thumbnailLeft"] = this.fluidDimensions.boxes[j]['left'];
            files[i]["objects"][j]["thumbnailTop"] = this.fluidDimensions.boxes[j]['top'];
            const displayFactor = 2;
            var imgTransUrl = files[i]["objects"][j]["imageTranscodeUrl"].split("size=")[0];  
            let url = imgTransUrl + 'size=v&apiKey='+ ENV_CONSTANTS.envHeaders[GlobalClassInstance.ENV_NAME]["X-Api-Key"] +'&devicetype=web&rotate=1&width='+files[i]["objects"][j]["thumbnailWidth"]*displayFactor+'&height='+files[i]["objects"][j]["thumbnailHeight"]*displayFactor;
            let type = this.universalService.checkIfImgTypeParamIsRequired(files[i]["objects"][j]["mimeSubType"]);
            url = url + type;
            if(this.universalService.currentTab == "PrivateFolder"){
							url = url + "&ppftoken="+encodeURIComponent(this.universalService.header_X_PPF_TOKEN);
						}
            files[i]["objects"][j]["imageTranscodeUrl"]= url;
            // files[i]["objects"][j]["imageTranscodeUrl"]= url.includes('.com') ? url.split(".com")[1] : url;
            
          }
        }

        return files;
  }


}
